import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const ShareIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M7.4 6.866a1.06 1.06 0 0 0-.777.333L3.067 5.334a1.049 1.049 0 0 0 .005-.724L6.59 2.76a1.066 1.066 0 1 0-.236-.477L2.771 4.166a1.067 1.067 0 1 0-.01 1.61L6.366 7.67A1.067 1.067 0 1 0 7.4 6.866Zm0-5.333A.534.534 0 1 1 7.4 2.6.534.534 0 0 1 7.4 1.533ZM2.066 5.499a.534.534 0 1 1-.002-1.068.534.534 0 0 1 .002 1.068Zm5.332 2.967a.534.534 0 1 1 0-1.068.534.534 0 0 1 0 1.068Z" />
        </SvgIcon>
    );
};
